declare global {
  interface Window {
    __LOVIBOOK_CONFIG__?: {
      authApiBaseUrl?: string;
    };
  }
}

const runtimeAuthApiBaseUrl =
  typeof window !== 'undefined' ? window.__LOVIBOOK_CONFIG__?.authApiBaseUrl : undefined;

export const AUTH_API_BASE_URL =
  runtimeAuthApiBaseUrl?.replace(/\/+$/, '') ??
  process.env.REACT_APP_AUTH_API_BASE_URL?.replace(/\/+$/, '') ??
  'https://nu2nqrm5qh.execute-api.us-west-2.amazonaws.com/prod';

export const AUTH_PASSWORD_POLICY_TEXT =
  'Password must be at least 8 characters and include an uppercase letter, a lowercase letter, and a number.';
